import { render } from "./Index.vue?vue&type=template&id=f9d3dc34"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=f9d3dc34&lang=scss"

import exportComponent from "/codebuild/output/src2335455550/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__